import React, { Fragment, useState, useEffect } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
  Card,
  CardBody,
} from 'reactstrap';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import {
  gAPI_Property_List_By_Group,
  gAPI_Internal_Property_By_Id,
  dAPI_Delete_Ingetration,
  API_Phone_Suite_Interation_Group,
  API_Phone_Suite,
} from '../../../../../../constants/APIs';
import { NavLink } from 'react-router-dom';
import { faLanguage, faSms } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IntegrationInfo from './IntegrationInfo';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import ConnectWareSettings from './ConnectWareSettings';
import ComingSoon from './ComingSoon';
import Features from './Features';
import ConfigurationBehavior from './configurationBehavior';
import SMS from './SMS';
import Topics from './Topics';
function PhoneSuiteIntegrationList({ match, locale, propertyId }) {
  const integrationId = match.params.id;
  const [integration, setIntegration] = useState();
  const [allProperties, setAllProperties] = useState([]);
  const [propertyVisible, setPropertyVisible] = useState(true);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [connectWareVisible, setConnectWareVisible] = useState(false);
  const [deleteVisible, setDeleteVisible] = useState(false);
  const [publishVisible, setPublishVisible] = useState(false);
  const [langVisible, setLangVisible] = useState(false);
  const [smsVisible, setSMSVisile] = useState(false);
  const [voiceAssistantVisible, setVoiceAssistantVisible] = useState(false);
  const [configurationVisible, setConfiguraionVisible] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [topics, setTopics] = useState(false);

  const sms = () => {
    setSMSVisile(true);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setTopics(false);
    setVoiceAssistantVisible(false);
  };
  const property = () => {
    setSMSVisile(false);
    setPropertyVisible(true);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const connectWareSettings = () => {
    setSMSVisile(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setTopics(false);
    setConnectWareVisible(true);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const features = () => {
    setSMSVisile(false);
    setPropertyVisible(false);
    setFeaturesVisible(true);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const language = () => {
    setSMSVisile(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setTopics(false);
    setPublishVisible(false);
    setLangVisible(true);
    setVoiceAssistantVisible(false);
  };

  const voiceAssistant = () => {
    setSMSVisile(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setTopics(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(true);
  };

  const configuration = () => {
    setSMSVisile(false);
    setPropertyVisible(false);
    setTopics(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(true);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const publish = () => {
    setSMSVisile(false);
    setTopics(false);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setPublishVisible(true);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  const handleTopics = () => {
    setSMSVisile(false);
    setTopics(true);
    setPropertyVisible(false);
    setFeaturesVisible(false);
    setConnectWareVisible(false);
    setConfiguraionVisible(false);
    setPublishVisible(false);
    setLangVisible(false);
    setVoiceAssistantVisible(false);
  };

  useEffect(() => {
    LoadIntegration();
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${getGroupID()}`,
    }).then((res) => {
      setPropertyData(res.data);
    });
  }, [integrationId]);
  useEffect(() => {
    AxiosAPI({
      method: 'get',
      url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
    }).then((res) => {
      setAllProperties(res.data);
    });
  }, []);
  const toggle = () => {
    setDeleteVisible(!deleteVisible);
  };
  const LoadIntegration = () => {
    AxiosAPI({
      method: 'get',
      url: `${API_Phone_Suite}/${integrationId}?group_id=${getGroupID()}`,
    })
      .then((res) => {
        setIntegration(res.data);
      })
      .catch((err) => console.log('err', err));
  };

  const updateModel = integration
    ? {
      name: integration.name,
      properties: integration.properties,
      defaultLanguage: 'en-US',
      sessionTimeoutInSeconds: integration.sessionTimeoutInSeconds,
      connectionSettings:
        integration?.phoneSuiteIntegration?.connectionSettings,
      features: integration?.phoneSuiteIntegration?.features,
      configurationSettings:
        integration?.phoneSuiteIntegration?.configurationSettings,
      smsSettings: integration?.phoneSuiteIntegration?.smsSettings,
    }
    : null;

  const saveIntegration = (data) => {
    const {
      list,
      name,
      configurationSettings,
      smsSettings,
      features,
      connectionSettings,
      topics,
    } = data;
    if (list) {
      updateModel.properties = list;
    }
    if (topics) updateModel.topics = topics;
    if (name) {
      updateModel.name = name;
    }
    if (connectionSettings) {
      updateModel.connectionSettings = connectionSettings;
    }
    if (configurationSettings) {
      updateModel.configurationSettings = configurationSettings;
    }
    if (smsSettings) {
      updateModel.smsSettings = smsSettings;
    }
    if (features) {
      updateModel.features = features;
    }

    AxiosAPI({
      method: 'put',
      url: `${API_Phone_Suite}/${integration.id}?group_id=${getGroupID()}`,
      data: updateModel,
    })
      .catch((err) => console.error(err))
      .then(() => {
        let groupRequest = {
          groupId: getGroupID(),
          propertyId: updateModel.properties[0],
          domain:
            updateModel.connectionSettings.sipGateway === 'Myma.ai'
              ? updateModel.connectionSettings.originatingPhoneNumber
              : updateModel.connectionSettings.domain,
          inboundTrunkName: updateModel.connectionSettings.inboundTrunk,
          creator: 'Dashboard',
        };
        groupRequest.integrationId = integration.id;
        AxiosAPI({
          method: 'put',
          url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
          data: groupRequest,
        }).then(() => { });
        LoadIntegration();
        NotificationManager.success(
          '',
          'Integration update successfully',
          3000,
          null,
          null,
          'success'
        );
      });
  };
  const handleDelete = () => {
    AxiosAPI({
      method: 'delete',
      url: `${dAPI_Delete_Ingetration}/${integration.id
        }/?group_id=${getGroupID()}`,
    }).then((res) => {
      let updateRequest = {
        updater: 'dashboard',
      };
      AxiosAPI({
        method: 'delete',
        url: `${API_Phone_Suite_Interation_Group}/${integration.id}`,
        data: updateRequest,
      })
        .then((result) => {
          toggle();
          window.location.href = '/app/pages/integration/applications';
        })
        .catch((err) => {
          console.log('err', err);
        });
    });
  };
  const generateDeleteButton = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={deleteVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This integration will be deleted!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => handleDelete()}
                    size="xs"
                  >
                    Delete
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggle}
                  >
                    Cancel
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };
  return (
    <Fragment>
      {integration ? (
        <Fragment>
          <Row>
            <Colxx md="12" sm="12" lg="12" xxs="12">
              <NavLink to={{ pathname: '/app/pages/integration/channels' }}>
                <h1 className="iconsminds-back" />
              </NavLink>
            </Colxx>
          </Row>
          <Row>
            <Colxx xxs="12" md="6" className="mb-4">
              <Card>
                <CardBody>
                  <div
                    className={`mb-3 integration ${propertyVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-hotel`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => property()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Select Business
                          </p>
                          <p className="mb-4 text-small">
                            Select the business name for this integration
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${connectWareVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-security-settings`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => connectWareSettings()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            SIP Gateway
                          </p>
                          <p className="mb-4 text-small">
                            Configure the SIP Gateway to integration telephony
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${configurationVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div className={`glyph-icon iconsminds-mic`} />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => configuration()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Configure AI Voice Assistant Behavior
                          </p>
                          <p className="mb-4 text-small">
                            Select the flows, the call behavior, and the prompts
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${featuresVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon simple-icon-game-controller`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => features()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Features
                          </p>
                          <p className="mb-4 text-small">
                            Select the capabilities and features you want to
                            enable
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${smsVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faSms} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => sms()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            SMS
                          </p>
                          <p className="mb-4 text-small">
                            Choose the SMS capabilities
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${langVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <FontAwesomeIcon icon={faLanguage} className="fa" />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => language()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Language
                          </p>
                          <p className="mb-4 text-small">
                            Select the languages you want to support
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${voiceAssistantVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-security-settings`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => voiceAssistant()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Keep Your AI Voice Assistant Secure
                          </p>
                          <p className="mb-4 text-small">
                            Accept incoming calls only from known numbers
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div
                    className={`mb-3 integration ${publishVisible ? 'integration--active' : ''
                      }`}
                  >
                    <div className="glyph">
                      <div
                        className={`glyph-icon iconsminds-monitor---tablet`}
                      />
                    </div>
                    <NavLink
                      to="#"
                      className="w-40 w-sm-100"
                      onClick={(e) => publish()}
                    >
                      <Row>
                        <Colxx xxs="12" md="10">
                          <p className="list-item-heading mb-1 color-theme-1">
                            Publish your AI Voice Assistant
                          </p>
                          <p className="mb-4 text-small">
                            Setup the forwarding rules
                          </p>
                        </Colxx>
                        <Colxx xxs="12" md="2">
                          <div className="glyph">
                            <div
                              className={`glyph-icon-min iconsminds-arrow-forward-2`}
                            />
                          </div>
                        </Colxx>
                      </Row>
                    </NavLink>
                    <Separator />
                  </div>
                  <div>
                    <Button
                      color="dark"
                      outline
                      style={{
                        width: '100%',
                        borderRadius: '6px',
                      }}
                      className="mb-4"
                      onClick={toggle}
                    >
                      Archive
                    </Button>

                    <Separator />
                  </div>
                </CardBody>
              </Card>
            </Colxx>
            <Colxx xxs="12" md="6" className="mb-4">
              {propertyVisible && (
                <Fragment>
                  <IntegrationInfo
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={
                      integration.properties === null
                        ? []
                        : integration.properties
                    }
                    allProperties={allProperties}
                  />
                  {/* <Example url="https://assets.bookmebob.com/images/integration-example/properties.png" /> */}
                </Fragment>
              )}
              {langVisible && (
                <Fragment>
                  <ComingSoon label={'Languages'}></ComingSoon>
                </Fragment>
              )}
              {configurationVisible && (
                <Fragment>
                  <ConfigurationBehavior
                    locale={locale}
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                  />
                </Fragment>
              )}
              {smsVisible && (
                <Fragment>
                  <SMS
                    integration={integration}
                    saveIntegration={saveIntegration}
                  />
                </Fragment>
              )}
              {voiceAssistantVisible && (
                <Fragment>
                  <ComingSoon
                    label={'Keep Your AI Voice Assistant Secure'}
                  ></ComingSoon>
                </Fragment>
              )}
              {publishVisible && (
                <Fragment>
                  <Card className="mb-4">
                    <CardBody>
                      <div className="text-center mb-2">
                        <h6>Publish your AI Voice Assistant</h6>

                      </div>
                      <Separator className="mb-3" />
                      <Row className=' mr-2 mb-4'>
                        <Colxx xxs="12"  >
                          <h5 style={{ marginTop: '0.15rem' }}>Call Forwarding Options for Voice AI </h5>
                          <p className="mb-2">
                            There are two main ways to forward your calls to Voice AI:</p>

                          <h7 className="ml-2 mb-2"> Call Transfer</h7>
                          <p className="ml-2 mb-2">  A dedicated local number where Voice AI is active. Simply transfer any incoming call to this number for the AI to take over the conversation.
                          </p>
                          <h7 className=' ml-2 mb-2'>  SIP Trunking</h7>
                          <p className="ml-2">  Contact our support team to set up a SIP connection between your telephony provider and AI Voice.
                          </p>
                        </Colxx>

                        <Colxx xxs="12" >
                          <Separator className="mb-4 mt-4" />
                          <h5 style={{ marginTop: '0.15rem' }}>Forwarding Rules  </h5>

                          <p className="mb-2">
                            You can define when calls should be forwarded to Voice AI. Common conditional forwarding options include:</p>

                          <h7 className=' ml-2 mb-2'> Out of Business Hours</h7>
                          <p className=' ml-2 mb-2'>Automatically forward calls to Voice AI outside your operating hours. </p>
                          <h7 className=' ml-2 mb-2'> When Busy</h7>
                          <p className=' ml-2 mb-2'>  If your line is busy or unanswered, redirect calls to Voice AI.
                          </p>
                          <h7 className='ml-2 mb-2'> Always Forward</h7>
                          <p className=' ml-2'> Have Voice AI answer every call first. Based on the conversation, Voice AI can then transfer calls to the appropriate person or department.   </p>
                        </Colxx>
                      </Row>
                    </CardBody>
                  </Card>
                </Fragment>
              )}
              {connectWareVisible && (
                <Fragment>
                  <ConnectWareSettings
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                  />
                </Fragment>
              )}
              {topics && (
                <Fragment>
                  <Topics
                    integration={integration}
                    saveIntegration={saveIntegration}
                    integrationId={integration.id}
                  />
                  {/* <Example url="https://bmbuiassetsprod.blob.core.windows.net/images/integration-example/appearance.png" /> */}
                </Fragment>
              )}
              {featuresVisible && (
                <Fragment>
                  <Features
                    settings={integration?.phoneSuiteIntegration}
                    saveIntegration={saveIntegration}
                    integrationProperties={integration.properties}
                    allProperties={allProperties}
                    integration={integration}
                    botSettings={integration.botSettings}
                    locale={locale}
                  />
                </Fragment>
              )}
            </Colxx>
          </Row>
        </Fragment>
      ) : null}
      {generateDeleteButton()}
    </Fragment>
  );
}
const mapStateToProps = ({ settings }) => {
  const { propertyId, locale } = settings;
  return {
    propertyId,
    locale,
  };
};

export default injectIntl(
  connect(mapStateToProps, {})(PhoneSuiteIntegrationList)
);
